<template>
  <el-table-column
    prop="name"
    label="Termék név"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'name',
  };
</script>
